let page = {webinars: 1, expired: 1}
let loadingData = false;
let webinarLoadingFinished = false
let webinarExpiredLoadingFinished = false
let isAlreadyLoaded = false

$(function () {
    createInfiniteScroll()
    let items_number = parseInt($('#webinars-container-list').attr('data-items-number'))

    if (items_number < 3) {
        loadExpiredData(1)
        page.expired++
    }
});

function spinner(loader) {
    return {
        hide: () => {
            loader.addClass('d-none')
        },
        show: () => {
            loader.removeClass('d-none')
        },
    }
}

function loadData() {
    var params = location.search !== '' ? location.search + '&page=' + page.webinars : '?page=' + page.webinars
    const loader = $("#webinars-loader")

    $.ajax(
        {
            url: params,
            type: "get",
            beforeSend: function()
            {
                spinner(loader).show()
                loadingData = true;
            }
        })
        .done(function(data)
        {
            const webinarContent = $('#webinars-content')

            loadingData = false;
            spinner(loader).hide()
            var html = data.data.html;

            if (! html) {
                webinarLoadingFinished = true
                loadExpiredData(page.expired)

                return;
            }

            webinarContent.append(html)
        })
        .fail(function(jqXHR, ajaxOptions, thrownError)
        {
            webinarLoadingFinished = true
            spinner(loader).hide()
        });
}

function loadExpiredData(page_to_load) {
    const webinarExpiredSection = $("#webinar-expired-section")
    const loader = $("#webinars-expired-loader")
    $.ajax(
        {
            url: "webinars/expired",
            type: "post",
            data: {
                page: page_to_load
            },
            beforeSend: function()
            {
                spinner(loader).show()
                loadingData = true;
            }
        })
        .done(function(data)
        {
            const webinarExpiredContent = $('#webinar-expired-content')
            loadingData = false;

            isAlreadyLoaded=false

            spinner(loader).hide()
            var html = data.data.html;

            if (! html) {
                webinarExpiredLoadingFinished = true
                return;
            }

            webinarExpiredSection.removeClass('d-none')
            webinarExpiredContent.append(html)
        })
        .fail(function(jqXHR, ajaxOptions, thrownError)
        {
            webinarExpiredLoadingFinished = true
            spinner(loader).hide()
        });
}

function createInfiniteScroll() {

    $(window).scroll(function() {
        if($(window).scrollTop() + $(window).height() >= $("#webinars-container-list").height()) {

            if (loadingData) {
                return;
            }

            if (! webinarLoadingFinished) {
                page.webinars++;
                loadData()
                return;
            }

            if (! webinarExpiredLoadingFinished) {
                page.expired++;
                isAlreadyLoaded = true;
                loadExpiredData(page.expired)
            }
        }
    });
}